import { rem } from "@mantine/core"
import { useClipboard } from "@mantine/hooks"
import { IconCopy, IconCheck } from "@tabler/icons-react"

import { Button, ButtonProps } from "../../../atoms/Button/Button.tsx"

import classes from "./CopyButton.module.css"

type CopyButtonProps = {
  copyableText: string
  admin?: boolean
  title?: string
  label?: string
} & Omit<ButtonProps, "children">

export const CopyButton = ({
  copyableText,
  admin,
  label,
  size,
  title,
  ...props
}: CopyButtonProps) => {
  const clipboard = useClipboard()
  return (
    <Button
      size={size}
      variant={admin ? "admin-tertiary" : "secondary"}
      toolTip={label ?? undefined}
      classNames={classes}
      rightSection={
        clipboard.copied ? (
          <IconCheck style={{ width: rem(20), height: rem(20) }} stroke={1.5} />
        ) : (
          <IconCopy style={{ width: rem(20), height: rem(20) }} stroke={1.5} />
        )
      }
      onClick={() => clipboard.copy(copyableText)}
      {...props}
    >
      {title ? title : copyableText}
    </Button>
  )
}
